import { useEffect, useState } from 'react'
import { throttle } from 'throttle-debounce'
import { Icon } from '@captaincause/ui/Icon'
import { tm } from '@captaincause/ui/tm'
import { Button } from 'components/Button'
import type { Campaign } from '@captaincause/types'

interface ScrollPromptProps {
  campaign?: Campaign
  onClick: () => void
  threshold?: number
}

export function ScrollPrompt({
  campaign = undefined,
  onClick,
  threshold = 300,
}: ScrollPromptProps) {
  const [hidden, setHidden] = useState(false)

  useEffect(() => {
    function toggleVisible() {
      setHidden(document?.documentElement?.scrollTop > threshold)
    }

    const throttledToggleVisible = throttle(400, toggleVisible)

    window.addEventListener('scroll', throttledToggleVisible)

    return () => {
      window.removeEventListener('scroll', throttledToggleVisible)
    }
  }, [threshold])

  return (
    <Button
      variant="raw"
      className={tm(
        'opacity-1 hover:opacity-1 active:opacity-1 focus:opacity-1 fixed bottom-6 left-1/2 z-20 animate-bounce rounded-lg bg-white p-2 shadow-lg md:hidden',
        hidden && 'opacity-0 hover:opacity-0 focus:opacity-0 active:opacity-0',
      )}
      style={{
        background: campaign?.button_color || '#000000',
        translate: '-50% 0',
      }}
      onClick={onClick}
    >
      <Icon
        icon="arrow-downward"
        style={{ fill: campaign?.button_text_color || '#FFFFFF' }}
      />
    </Button>
  )
}
